import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/images/news-icon.png';
import _imports_1 from '@/assets/images/wechat_official_account.png';
import _imports_2 from '@/assets/images/little_red_book.png';
import _imports_3 from '@/assets/images/douyin.png';
import _imports_4 from '@/assets/images/close-icon.svg';
import _imports_5 from '@/assets/images/contact.png';
const _hoisted_1 = { class: "news-view" };
const _hoisted_2 = { class: "content" };
const _hoisted_3 = { class: "section news-section" };
const _hoisted_4 = { class: "container" };
const _hoisted_5 = { class: "news-grid" };
const _hoisted_6 = { class: "news-image" };
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = { class: "news-content" };
import { onMounted, ref } from 'vue';
import NavBar from '@/components/NavBar.vue';
import news1 from '@/assets/images/news1.png';
import news2 from '@/assets/images/news2.png';
import news3 from '@/assets/images/news3.png';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NewsView',
    setup(__props) {
        const newsImages = [news1, news2, news3];
        const showModal = ref(false);
        // 初始化滚动动画
        onMounted(() => {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                    }
                });
            }, { threshold: 0.1 });
            document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
        });
        const handlePayClick = () => {
            showModal.value = true;
        };
        const closeModal = () => {
            showModal.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "background-wrapper" }, [
                    _createElementVNode("div", { class: "background-image" })
                ], -1)),
                _createVNode(NavBar, { white: true }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("section", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "section-header" }, [
                                _createElementVNode("div", { class: "title-wrapper" }, [
                                    _createElementVNode("img", {
                                        src: _imports_0,
                                        alt: "新闻图标",
                                        class: "news-icon"
                                    }),
                                    _createElementVNode("h2", { class: "section-title" }, "行业资讯")
                                ])
                            ], -1)),
                            _createElementVNode("div", _hoisted_5, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                                    return _createElementVNode("div", {
                                        class: "news-item",
                                        key: i
                                    }, [
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("img", {
                                                src: newsImages[i - 1],
                                                alt: `新闻${i}`
                                            }, null, 8, _hoisted_7)
                                        ]),
                                        _createElementVNode("div", _hoisted_8, [
                                            (i === 1)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Deepseek R1可能找到了超越人类的办法", -1)),
                                                    _cache[2] || (_cache[2] = _createElementVNode("p", null, "1997年，IBM公司开发的国际象棋AI深蓝，击败了世界冠军卡斯帕罗夫而引发轰动；接近二十年后的2016年，由DeepMind开发的围棋AI AlphaGo击败了围棋世界冠军李世石，再次引发轰动。", -1)),
                                                    _createElementVNode("button", {
                                                        class: "pay-btn",
                                                        onClick: handlePayClick
                                                    }, "付费阅读：3元/篇")
                                                ], 64))
                                                : _createCommentVNode("", true),
                                            (i === 2)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _cache[3] || (_cache[3] = _createElementVNode("h3", null, "文心一言宣布全面免费", -1)),
                                                    _cache[4] || (_cache[4] = _createElementVNode("p", null, "2月13日，百度正式宣布，文心一言将于4月1日0时起全面免费开放。这一消息发布后，百度港股股价涨幅一度超过10%，创下去年10月以来的新高；其美股也表现强劲，涨幅达到4.36%。", -1)),
                                                    _createElementVNode("button", {
                                                        class: "pay-btn",
                                                        onClick: handlePayClick
                                                    }, "付费阅读：3元/篇")
                                                ], 64))
                                                : _createCommentVNode("", true),
                                            (i === 3)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                    _cache[5] || (_cache[5] = _createElementVNode("h3", null, "你的工作会被AI取代吗？从2025年AI应用全景图趋势报告看2025职业变革", -1)),
                                                    _cache[6] || (_cache[6] = _createElementVNode("p", null, "2025年人工智能应用生态系统的一切你都需要了解。人工智能应用已从新奇事物转变为移动领域的重要组成部分。在本报告中，我们深入研究人工智能应用市场，根据全球最受欢迎的1000款人工智能应用的性能数据，探索机遇和增长模式。这些数据清晰地表明：自推出以来，全球顶级人工智能应用的下载量已超过10亿次，消费者支出超过18亿美元。", -1)),
                                                    _createElementVNode("button", {
                                                        class: "pay-btn",
                                                        onClick: handlePayClick
                                                    }, "付费阅读：3元/篇")
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]);
                                }), 64))
                            ])
                        ])
                    ])
                ]),
                _cache[11] || (_cache[11] = _createStaticVNode("<footer class=\"footer\" data-v-43f2a399><div class=\"container\" data-v-43f2a399><div class=\"footer-content\" data-v-43f2a399><div class=\"footer-info\" data-v-43f2a399><p data-v-43f2a399>©2025 北京甜蜜双排科技有限公司 版权所有</p><p data-v-43f2a399>ICP备案号：京ICP备2025115613号</p><p data-v-43f2a399>地址：北京市通州区新华北路55号2幢四层11-806室</p><p data-v-43f2a399>邮箱：service@ranklovin.com</p><p data-v-43f2a399>联系电话：19928743352</p></div><div class=\"footer-social\" data-v-43f2a399><div class=\"social-item\" data-v-43f2a399><img src=\"" + _imports_1 + "\" alt=\"微信公众号\" data-v-43f2a399><span data-v-43f2a399>微信公众号</span></div><div class=\"social-item\" data-v-43f2a399><img src=\"" + _imports_2 + "\" alt=\"小红书\" data-v-43f2a399><span data-v-43f2a399>小红书</span></div><div class=\"social-item\" data-v-43f2a399><img src=\"" + _imports_3 + "\" alt=\"抖音\" data-v-43f2a399><span data-v-43f2a399>抖音</span></div></div></div></div></footer>", 1)),
                (showModal.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal-overlay",
                        onClick: closeModal
                    }, [
                        _createElementVNode("div", {
                            class: "modal-content",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("button", {
                                class: "close-btn",
                                onClick: closeModal
                            }, _cache[8] || (_cache[8] = [
                                _createElementVNode("img", {
                                    src: _imports_4,
                                    alt: "关闭"
                                }, null, -1)
                            ])),
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "modal-body" }, [
                                _createElementVNode("img", {
                                    src: _imports_5,
                                    alt: "企业微信二维码",
                                    class: "qr-code"
                                })
                            ], -1))
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
